import http from '@/services/rest/rest.service';
import {ICaptcha} from '@/entities/captcha.interface';

export default {
    image(): Promise<ICaptcha> {
        return http.get('/captcha');
    },
};
